import { render, staticRenderFns } from "./SettingsAdd.vue?vue&type=template&id=5530b4f2&"
import script from "./SettingsAdd.vue?vue&type=script&lang=js&"
export * from "./SettingsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports